/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import UserName from 'solis/claude/element/user/name';


const getBoard = ({ zoneTimeline, currentDate }) =>
{
  return zoneTimeline.getZone(currentDate).getBoard();
};


const getWinner = ({ zoneTimeline, currentDate }) =>
{
  return zoneTimeline.getWinner(currentDate);
};


export default (props) =>
(
  <UserName board = {getBoard(props)} user = {getWinner(props)} />
);
